import React from "react";
import styles from "./ButtonTutorial.module.scss";

function ButtonTutorial({ icon, title, subtitle, theme = "green", onClick, address }) {
  const buttonClass = `${styles["card-button"]} ${styles[`theme--${theme}`]}`;

  return (
    <>
      <button className={buttonClass} onClick={() => onClick("null")}>
        <div className={styles["icon-wrapper"]}>{icon}</div>
        <div className={styles["text"]}>
          <h3 className={styles["title"]}>{title}</h3>
        </div>
      </button>
      <div className={styles["reference"]}>
        <p className={styles["subtitle"]}>{subtitle}</p>
        <a href={address} target="_blank" className={styles["address"]} rel="noreferrer">
          {address}
        </a>
      </div>
    </>
  );
}

export default ButtonTutorial;
